// Classes do QGC; manter em sincronia com CreditorImportService.CLAIM_CLASSES na API.
const data = [
  { id: 1, name: "Classe I - Trabalhista" },
  { id: 2, name: "Classe II - Garantia Real" },
  { id: 3, name: "Classe III - Quirografários" },
  { id: 4, name: "Classe IV - ME/EPP" },
  { id: 5, name: "Classe V - Outros" },
  { id: 6, name: "Tributário" },
];

export default [...data];
